import React from 'react'
import { useTranslation } from 'react-i18next';

const Parteners = () => {
  const { t } = useTranslation();
  
  return (
    <div className="test_block">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <h3 className="main-content__main-products desktop-title">{t('partners.title')}</h3>
                    <div className="desktop-content">
                        <p>{t('partners.description1')}</p>
                        <p>{t('partners.description2')}</p>
                    </div>
                    <div className="up_cntent">
                        <h4>•	{t('partners.section1.title')}</h4>
                        <p>{t('partners.section1.description')}</p>
                    </div>
                    <div className="up_cntent">
                        <h4>•	{t('partners.section2.title')}</h4>
                        <p>{t('partners.section2.description')}</p>
                    </div>
                    <div className="contain-infor">
                        <h3>{t('partners.whoCanBePartner.title')}</h3>
                        {t('partners.whoCanBePartner.list', { returnObjects: true }).map((item, index) => (
                            <p key={index}>{item}</p>
                        ))}
                        <p>{t('partners.whoCanBePartner.contactUs')} <a className='green' href="mailto:frigidercomunitar@gmail.com"> {t('contactUs')} </a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Parteners